import { QTheme } from '@qualio/ui-components';

export const theme = {
  ...QTheme,
};
